module.exports = __webpack_public_path__ + "static/media/VERYMB.d45eff38.svg";